import { ISODateStringToUTCDate } from './ISODateStringToUTCDate';

// Assumes a format of "YYYYMMDD-XXXX"
export const getBirthDate = (identificationNumber: string): Date | null => {
  identificationNumber = identificationNumber.replaceAll('-', '');
  identificationNumber = identificationNumber.slice(0, 8);

  if (identificationNumber.length < 8) return null;

  identificationNumber = handleCoordinationNumber(identificationNumber);

  identificationNumber = `${identificationNumber.slice(0, 4)}-${identificationNumber.slice(
    4,
    6
  )}-${identificationNumber.slice(6, 8)}`;

  const birthDate = ISODateStringToUTCDate(identificationNumber);
  return birthDate;
};

const handleCoordinationNumber = (identificationNumber: string): string => {
  const day = Number(identificationNumber.slice(6, 8));

  // Coordination numbers have 60 added days
  if (day > 60) {
    const dayString = (day - 60).toString().padStart(2, '0');

    return `${identificationNumber.slice(0, 6)}${dayString}`;
  }

  return identificationNumber;
};
